import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_PROVIDER_LIST = "GET_PROVIDER_LIST";

export const service = async (data) => {
  const options = {
    url: `/api/Provider/GetProviderList?${data.query}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PROVIDER_LIST, service, mock);
